var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "audio-play", on: { "click": _vm.toggle } }, [_c('svg-icon', { attrs: { "icon-class": _vm.type, "size": 24 } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };